<app-header></app-header>

<div class="pd-header">
  <div class="pd-title">User Administration</div>
  <div class="pd-actions">
    <button class="round" type="button" (click)="refreshLists()" [disabled]="isLoading()">
      <img src="/assets/images/Refresh_Admin.png" alt="Refresh">
    </button>
  </div>
</div>

<div class="pd-content">

  <div class="divider"></div>

  <!-- User Lists -->
  <div class="users-section">
    <div class="section-title">Users</div>
    <div class="user-lists">
      <div class="user-list" *ngFor="let section of roleSections; trackBy: trackRoleSection">
        <button class="list-header" type="button" (click)="toggleRoleOpen(section.role)">
          <h3>{{ section.label }} ({{ getSectionUserCount(section) }})</h3>
          <img class="list-chevron" [class.rotated]="isRoleOpen(section.role)" src="/assets/images/Filters_Chevron_Icon.png" alt="toggle">
        </button>
        <div class="list-container" [class.collapsed]="!isRoleOpen(section.role)">
          <div class="list-filter" *ngIf="shouldShowRoleFilter(section) || shouldShowUsernameFilter(section)">
            <div class="edit-label" *ngIf="shouldShowRoleFilter(section)">Filter by {{ getRoleFilterLabel(section) }}</div>
            <app-shared-dropdown
              *ngIf="shouldShowRoleFilter(section)"
              [options]="getRoleFilterOptions(section.role, getRoleFilterLabel(section))"
              [selectedValue]="getRoleFilterValue(section.role)"
              [placeholder]="'All ' + getRoleFilterLabel(section)"
              [label]="getRoleFilterLabel(section)"
              [searchable]="true"
              (selectionChange)="onRoleFilterChange(section.role, $event)">
            </app-shared-dropdown>
            <div class="edit-label" *ngIf="shouldShowUsernameFilter(section)">Filter by Username</div>
            <app-shared-dropdown
              *ngIf="shouldShowUsernameFilter(section)"
              [options]="getRoleUserFilterOptions(section.role)"
              [selectedValue]="getRoleUserFilterValue(section.role)"
              [placeholder]="'All Usernames'"
              [label]="'Username'"
              [searchable]="true"
              (selectionChange)="onRoleUserFilterChange(section.role, $event)">
            </app-shared-dropdown>
          </div>
          <div class="list-scroll">
            <div class="empty-state" *ngIf="!isLoading() && getSectionUserCount(section) === 0">
              <div class="empty-text">No {{ section.label.toLowerCase() }} users found</div>
            </div>
            @if (section.role === 'Scheduler') {
              @for (u of getSchedulerGroupedUsers(); track trackSchedulerGrouped($index, u)) {
                <div class="user-item" [class.inactive]="!isUserActive(u)">
                  <div class="user-info">
                    <div class="user-name">{{ u.employeeName || u.username }}</div>
                    <div class="user-email">{{ u.username }}</div>
                    <div class="user-meta" *ngIf="section.mappingLabel">
                      {{ section.mappingLabel }}: {{ formatMappingName(u) }}
                    </div>
                    <div class="user-status" *ngIf="!isUserActive(u)">Inactive</div>
                  </div>
                  <div class="user-actions">
                    <button class="edit-btn"
                         type="button"
                         [disabled]="isEditDisabled(u)"
                         [attr.title]="isEditDisabled(u) ? 'You cannot edit your own account' : 'Edit user'"
                         (click)="$event.stopPropagation(); openEditModal(u, section.role)">
                      Edit
                    </button>
                    <button class="deactivate-btn"
                         *ngIf="isUserActive(u)"
                         type="button"
                         [disabled]="isDeactivateDisabled(u)"
                         [attr.title]="isDeactivateDisabled(u) ? 'You cannot deactivate your own account' : 'Deactivate'"
                         (click)="$event.stopPropagation(); onDeactivate(u, section.role)">
                      Deactivate
                    </button>
                    <span class="activate-tooltip" *ngIf="!isUserActive(u)" [attr.title]="getActivateTitle(u, section.role)">
                      <button class="activate-btn"
                           type="button"
                           [disabled]="isActivateDisabled(u, section.role)"
                           (click)="$event.stopPropagation(); onActivate(u, section.role)">
                        Activate
                      </button>
                    </span>
                  </div>
                </div>
              }
            } @else {
              @for (u of getFilteredUsers(section.role); track trackRoleUser($index, u)) {
                <div class="user-item" [class.inactive]="!isUserActive(u)">
                  <div class="user-info">
                    <div class="user-name">{{ u.employeeName || u.username }}</div>
                    <div class="user-email">{{ u.username }}</div>
                    <div class="user-meta" *ngIf="section.mappingLabel">
                      {{ section.mappingLabel }}: {{ formatMappingName(u) }}
                    </div>
                    <div class="user-status" *ngIf="!isUserActive(u)">Inactive</div>
                  </div>
                  <div class="user-actions">
                    <button class="edit-btn"
                         type="button"
                         [disabled]="isEditDisabled(u)"
                         [attr.title]="isEditDisabled(u) ? 'You cannot edit your own account' : 'Edit user'"
                         (click)="$event.stopPropagation(); openEditModal(u, section.role)">
                      Edit
                    </button>
                    <button class="deactivate-btn"
                         *ngIf="isUserActive(u)"
                         type="button"
                         [disabled]="isDeactivateDisabled(u)"
                         [attr.title]="isDeactivateDisabled(u) ? 'You cannot deactivate your own account' : 'Deactivate'"
                         (click)="$event.stopPropagation(); onDeactivate(u, section.role)">
                      Deactivate
                    </button>
                    <span class="activate-tooltip" *ngIf="!isUserActive(u)" [attr.title]="getActivateTitle(u, section.role)">
                      <button class="activate-btn"
                           type="button"
                           [disabled]="isActivateDisabled(u, section.role)"
                           (click)="$event.stopPropagation(); onActivate(u, section.role)">
                        Activate
                      </button>
                    </span>
                  </div>
                </div>
              }
            }
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="divider"></div>

  <!-- Create User Form -->
  <div class="form-section">
    <div class="section-title">Create User</div>
    <div class="edit-group">
      <div class="edit-row">
        <label class="edit-label" for="create-username">Username (Email)</label>
        <div class="origin-box">
          <input id="create-username" class="filter-input" type="email" [ngModel]="create.username()" (ngModelChange)="create.username.set($event)" placeholder="Enter email address" />
        </div>
      </div>
      <div class="edit-row">
        <label class="edit-label" for="create-employee-name">Employee Name</label>
        <div class="origin-box">
          <input id="create-employee-name" class="filter-input" type="text" [ngModel]="create.employeeName()" (ngModelChange)="create.employeeName.set($event)" placeholder="Enter full name" />
        </div>
      </div>
      <div class="edit-row">
        <div class="edit-label">Role</div>
        <app-shared-dropdown
          [options]="getRoleDropdownOptions()"
          [selectedValue]="create.role()"
          placeholder="Select role"
          label="Role"
          (selectionChange)="onSelectCreateRoleValue($event)">
        </app-shared-dropdown>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Grower'">
        <div class="edit-label">Grower Account</div>
        <div class="grower-account-row">
          <app-shared-dropdown
            [options]="getGrowerAccountOptions()"
            [selectedValue]="getDropdownValue(create.growerAccountId())"
            placeholder="Select grower account"
            label="Grower Account"
            [searchable]="true"
            (selectionChange)="setCreateGrowerAccountId($event)">
          </app-shared-dropdown>
          <div class="secondary-btn"
               role="button"
               tabindex="0"
               (click)="openGrowerAccountModal()"
               (keydown.enter)="openGrowerAccountModal()">Add Account</div>
        </div>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Transloader'">
        <div class="edit-label">Transloading Station</div>
        <app-shared-dropdown
          [options]="getTransloadingStationOptions()"
          [selectedValue]="getDropdownValue(create.transloadingStationId())"
          placeholder="Select transloading station"
          label="Transloading Station"
          (selectionChange)="setCreateTransloadingStationId($event)">
        </app-shared-dropdown>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Shunting'">
        <div class="edit-label">Plant</div>
        <app-shared-dropdown
          [options]="getShuntingCreatePlantOptions()"
          [selectedValue]="getDropdownValue(create.shuntingPlantId())"
          placeholder="Select plant"
          label="Plant"
          (selectionChange)="onShuntingPlantSelection($event)">
        </app-shared-dropdown>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Shunting'">
        <div class="edit-label">Shunting Yard</div>
        <app-shared-dropdown
          [options]="getShuntingYardOptions()"
          [selectedValue]="getDropdownValue(create.shuntingYardId())"
          placeholder="Select shunting yard"
          label="Shunting Yard"
          (selectionChange)="setCreateShuntingYardId($event)">
        </app-shared-dropdown>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Gatehouse' || create.role() === 'Receiver'">
        <div class="edit-label">Plant</div>
        <app-shared-dropdown
          [options]="getPlantOptions()"
          [selectedValue]="getDropdownValue(create.plantId())"
          placeholder="Select plant"
          label="Plant"
          (selectionChange)="setCreatePlantId($event)">
        </app-shared-dropdown>
      </div>

      <div class="edit-row" *ngIf="create.role() === 'Scheduler'">
        <div class="edit-label">Plants</div>
        <div class="multi-select">
          <label class="checkbox-item" *ngFor="let plant of getSchedulerPlants(); trackBy: trackPlant">
            <input type="checkbox" [checked]="isSchedulerPlantSelected(plant.plantID)" (change)="toggleSchedulerPlant(plant.plantID)" />
            <span>{{ plant.plantName }}</span>
          </label>
        </div>
      </div>
    </div>
    <div class="page-actions">
      <button class="outline filled" type="button" (click)="onCreate()" [disabled]="isCreateDisabled()">Create User</button>
    </div>
  </div>

  <!-- Add Grower Account Modal -->
  <div class="modal-overlay modal-overlay-top" *ngIf="showGrowerAccountModal()">
    <button
      class="modal-backdrop"
      type="button"
      aria-label="Close grower account modal"
      (click)="closeGrowerAccountModal()">
    </button>
    <dialog class="modal-card"
            open
            aria-label="Add Grower Account"
            (click)="$event.stopPropagation()"
            (keydown.escape)="closeGrowerAccountModal()">
      <div class="modal-header">
        <div class="modal-title">Add Grower Account</div>
        <button class="modal-close" type="button" (click)="closeGrowerAccountModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="edit-row">
          <label class="edit-label" for="grower-account-name">Account Name</label>
          <div class="origin-box">
            <input id="grower-account-name"
                   class="filter-input"
                   type="text"
                   [ngModel]="growerAccountName()"
                   (ngModelChange)="growerAccountName.set($event)"
                   placeholder="Enter account name" />
          </div>
        </div>
        <div class="edit-row">
          <label class="edit-label" for="grower-account-vendor-number">Vendor Number</label>
          <div class="origin-box">
            <input id="grower-account-vendor-number"
                   class="filter-input"
                   type="text"
                   [ngModel]="growerAccountVendorNumber()"
                   (ngModelChange)="growerAccountVendorNumber.set($event)"
                   placeholder="Enter vendor number" />
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button class="outline" type="button" (click)="closeGrowerAccountModal()">Cancel</button>
        <button class="outline filled" type="button" (click)="onCreateGrowerAccount()" [disabled]="isGrowerAccountCreateDisabled()">
          Save
        </button>
      </div>
    </dialog>
  </div>

  <!-- Edit Grower Account Modal -->
  <div class="modal-overlay modal-overlay-top" *ngIf="showEditGrowerAccountModal()">
    <button
      class="modal-backdrop"
      type="button"
      aria-label="Close edit grower account modal"
      (click)="closeEditGrowerAccountModal()">
    </button>
    <dialog class="modal-card"
            open
            aria-label="Edit Grower Account"
            (click)="$event.stopPropagation()"
            (keydown.escape)="closeEditGrowerAccountModal()">
      <div class="modal-header">
        <div class="modal-title">Edit Grower Account</div>
        <button class="modal-close" type="button" (click)="closeEditGrowerAccountModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="edit-row">
          <label class="edit-label" for="edit-grower-account-name">Account Name</label>
          <div class="origin-box">
            <input id="edit-grower-account-name"
                   class="filter-input"
                   type="text"
                   [ngModel]="editGrowerAccountModalName()"
                   (ngModelChange)="editGrowerAccountModalName.set($event)"
                   placeholder="Enter account name" />
          </div>
        </div>
        <div class="edit-row">
          <label class="edit-label" for="edit-grower-account-vendor-number">Vendor Number</label>
          <div class="origin-box">
            <input id="edit-grower-account-vendor-number"
                   class="filter-input"
                   type="text"
                   [ngModel]="editGrowerAccountModalVendorNumber()"
                   (ngModelChange)="editGrowerAccountModalVendorNumber.set($event)"
                   placeholder="Enter vendor number" />
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button class="outline" type="button" (click)="closeEditGrowerAccountModal()">Cancel</button>
        <button class="outline filled" type="button" (click)="onSaveEditGrowerAccount()" [disabled]="isEditGrowerAccountSaveDisabled()">
          Save
        </button>
      </div>
    </dialog>
  </div>

  <!-- Edit user modal -->
  <div class="modal-overlay" *ngIf="showEditModal() && !showGrowerAccountModal() && !showEditGrowerAccountModal()">
    <button
      class="modal-backdrop"
      type="button"
      aria-label="Close edit user modal"
      (click)="closeEditModal()">
    </button>
    <dialog class="modal-card"
            open
            aria-label="Edit user"
            (click)="$event.stopPropagation()"
            (keydown.escape)="closeEditModal()">
      <div class="modal-header">
        <div class="modal-title">Edit user</div>
        <button class="modal-close" type="button" (click)="closeEditModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="edit-row">
          <label class="edit-label" for="edit-username">Username (Email)</label>
          <div class="origin-box">
            <input id="edit-username"
                   class="filter-input"
                   type="email"
                   [ngModel]="editUsername()"
                   (ngModelChange)="editUsername.set($event)" />
          </div>
        </div>
        <div class="edit-row">
          <label class="edit-label" for="edit-employee-name">Employee name</label>
          <div class="origin-box">
            <input id="edit-employee-name"
                   class="filter-input"
                   type="text"
                   [ngModel]="editEmployeeName()"
                   (ngModelChange)="editEmployeeName.set($event)" />
          </div>
        </div>

        <div class="edit-row" *ngIf="editRole() === 'Grower'">
          <div class="edit-label">Grower account</div>
          <div class="grower-account-row">
            <app-shared-dropdown
              [options]="getGrowerAccountOptions()"
              [selectedValue]="getDropdownValue(editGrowerAccountId())"
              placeholder="Select grower account"
              label="Grower Account"
              [searchable]="true"
              (selectionChange)="setEditGrowerAccountId($event)">
            </app-shared-dropdown>
            <div class="secondary-btn"
                 role="button"
                 tabindex="0"
                 (click)="openGrowerAccountModal('edit')"
                 (keydown.enter)="openGrowerAccountModal('edit')">Add Account</div>
            <button class="secondary-btn"
                    type="button"
                    [disabled]="editGrowerAccountId() === null"
                    (click)="openEditGrowerAccountModal()">Edit Account</button>
          </div>
        </div>

        <div class="edit-row" *ngIf="editRole() === 'Transloader'">
          <div class="edit-label">Transloading station</div>
          <app-shared-dropdown
            [options]="getTransloadingStationOptions()"
            [selectedValue]="getDropdownValue(editTransloadingStationId())"
            placeholder="Select transloading station"
            label="Transloading Station"
            (selectionChange)="editTransloadingStationId.set(parseDropdownNumber($event))">
          </app-shared-dropdown>
        </div>

        <div class="edit-row" *ngIf="editRole() === 'Shunting'">
          <div class="edit-label">Plant</div>
          <app-shared-dropdown
            [options]="getShuntingCreatePlantOptions()"
            [selectedValue]="getDropdownValue(editShuntingPlantId())"
            placeholder="Select plant"
            label="Plant"
            (selectionChange)="onEditShuntingPlantSelection($event)">
          </app-shared-dropdown>
        </div>
        <div class="edit-row" *ngIf="editRole() === 'Shunting'">
          <div class="edit-label">Shunting yard</div>
          <app-shared-dropdown
            [options]="getEditShuntingYardOptions()"
            [selectedValue]="getDropdownValue(editShuntingYardId())"
            placeholder="Select shunting yard"
            label="Shunting Yard"
            (selectionChange)="editShuntingYardId.set(parseDropdownNumber($event))">
          </app-shared-dropdown>
        </div>

        <div class="edit-row" *ngIf="editRole() === 'Gatehouse' || editRole() === 'Receiver'">
          <div class="edit-label">Plant</div>
          <app-shared-dropdown
            [options]="getPlantOptions()"
            [selectedValue]="getDropdownValue(editPlantId())"
            placeholder="Select plant"
            label="Plant"
            (selectionChange)="editPlantId.set(parseDropdownNumber($event))">
          </app-shared-dropdown>
        </div>

        <div class="edit-row" *ngIf="editRole() === 'Scheduler'">
          <div class="edit-label">Plants</div>
          <div class="multi-select">
            <label class="checkbox-item" *ngFor="let plant of getSchedulerPlants(); trackBy: trackPlant">
              <input type="checkbox"
                     [checked]="isEditSchedulerPlantSelected(plant.plantID)"
                     (change)="toggleEditSchedulerPlant(plant.plantID)" />
              <span>{{ plant.plantName }}</span>
            </label>
          </div>
        </div>
      </div>
      <div class="modal-actions">
        <button class="outline" type="button" (click)="closeEditModal()">Cancel</button>
        <button class="outline filled" type="button" (click)="onSaveEdit()" [disabled]="isEditSaveDisabled()">
          Save
        </button>
      </div>
    </dialog>
  </div>

  <!-- Confirm Action Modal -->
  <div class="modal-overlay" *ngIf="showConfirmModal()">
    <button
      class="modal-backdrop"
      type="button"
      aria-label="Close confirmation modal"
      (click)="closeConfirmModal()">
    </button>
    <dialog class="modal-card"
            open
            aria-label="Confirm action"
            (click)="$event.stopPropagation()"
            (keydown.escape)="closeConfirmModal()">
      <div class="modal-header">
        <div class="modal-title">{{ confirmTitle() }}</div>
        <button class="modal-close" type="button" (click)="closeConfirmModal()">×</button>
      </div>
      <div class="modal-body">
        <div class="confirm-message">{{ confirmMessage() }}</div>
      </div>
      <div class="modal-actions">
        <button class="outline" type="button" (click)="closeConfirmModal()">Cancel</button>
        <button class="outline filled" type="button" (click)="onConfirmAction()">
          {{ getConfirmActionLabel() }}
        </button>
      </div>
    </dialog>
  </div>

  <!-- Error Display -->
  <div class="info-banner error-banner" *ngIf="errorText() as err">
    {{ err }}
  </div>
</div>

<app-loading-spinner [isLoading]="isLoading()" text="Loading users…"></app-loading-spinner>
<app-loading-spinner [isLoading]="isCreateSaving()" text="Creating user…"></app-loading-spinner>

<app-navbar [items]="[
  { id: 'profile', label: 'Profile', selectedIcon: '/assets/images/Person_Selected.png', unselectedIcon: '/assets/images/Person_Unselected.png' },
  { id: 'home', label: 'Homepage', selectedIcon: '/assets/images/Home_Selected.png', unselectedIcon: '/assets/images/Home_Unselected.png' },
  { id: 'contacts', label: 'Contacts', selectedIcon: '/assets/images/Contact_Selected.png', unselectedIcon: '/assets/images/Contact_Unselected.png' }
]" [selectedId]="'home'" (selectedIdChange)="onNavChange($event)"></app-navbar>


